import React from 'react';
import {
	GroupedMultipleDropdownShared,
	IGroupedMultipleDropdownProps,
} from '@shared/components/Dropdowns/DesignSystem/MultipleDropdown/GroupedMultipleDropdown/GroupedMultipleDropdownShared';

export const GroupedMultipleDropdown = <T,>(props: IGroupedMultipleDropdownProps<T>) => {
	return <GroupedMultipleDropdownShared {...props} />;
};
